import React, { useRef } from "react";
import { useDateFieldState } from "react-stately";
import { useDateField, useDateSegment, useLocale } from "react-aria";
import { createCalendar } from "@internationalized/date";
import styled, { css } from "styled-components";

export function DateField(props) {
  let { locale } = useLocale();
  locale = locale.replace("he", "en");
  const state = useDateFieldState({ ...props, locale, createCalendar });
  const ref = useRef();
  const { fieldProps } = useDateField(props, state, ref);
  return (
    <DateFieldContainer {...fieldProps} ref={ref}>
      {state.segments.map((segment, i) => (
        <DateSegment key={i} segment={segment} state={state} />
      ))}
    </DateFieldContainer>
  );
}

const DateFieldContainer = styled.div`
  display: flex;
  border-radius: 0.375rem;
  transition: all 200ms;
`;

export const StyledField = styled.div`
  cursor: pointer;
  border: none;
  text-align: end;
  outline: none;
  transition: all 200ms;
  display: flex;
  align-items: center;
`;

function DateSegment({ segment, state }) {
  const ref = useRef();
  const { segmentProps } = useDateSegment(segment, state, ref);

  return (
    <DateSegmentContainer
      {...segmentProps}
      segment={segment}
      ref={ref}
      style={segmentProps.style}
    >
      {segment.text}
    </DateSegmentContainer>
  );
}

const DateSegmentContainer = styled.div`
  font-variant-numeric: tabular-nums;
  box-sizing: content-box;
  padding-inline: 0.1rem;
  outline: none;
  outline-offset: 2px;
  border-radius: 0.375rem;
  text-align: center;
  color: inherit;
  opacity: ${({ segment }) => (segment.isPlaceholder ? 0.6 : 1)};
  &:focus {
    font-weight: 600;
  }
  ${({ segment }) => {
    if (!segment.placeholder) return;
    return css`
      min-width: ${segment.placeholder.length}ch;
    `;
  }}
`;
